import { FC, KeyboardEvent, useState } from "react";
import useListTracking, { Props, ReceivedProps } from "./hook";
import { Styles } from "./styled";

import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import StylesMain from "../components/StyleMain";
import HeaderTitle from "../components/HeaderTitle";
import { Tooltip } from "antd";
import moment, { Moment } from "moment";
import { DATE_TIME_FORMAT } from "@lhd/constants";
import CommonDatePicker from "@lhd/components/CommonDatePicker";
import TableList from "./TableList";
import { isMobile, isTablet } from "react-device-detect";
import { HiArrowUturnLeft } from "react-icons/hi2";

import AddTrackingModal from "./AddTrackingModal";
import ButtonCommon from "@lhd/components/ButtonCommon";
import ButtonCancel from "@lhd/components/ButtonCancel";
import ButtonBack from "@lhd/components/ButtonBack";
import ToolbarSeparator from "@lhd/components/ToolbarSeparator";
import { UndoIcon } from "@lhd/assets";
import { BiPlus, BiSave } from "react-icons/bi";
import { MODE } from "@lhd/types";
import DayChangeTimeSetting from "../components/DayChangeTimeSetting";
import MonthlySummary, { formatTimeWithDecimal } from "./MonthlySummary";

const ListTrackingLayout: FC<Props> = (props) => {
  const isMobileOrTablet = isMobile || isTablet;
  const {
    monthPickerValue,
    onMonthChange,
    page,
    perPage,
    onChangePagination,
    monthlyRecords,
    monthlyMaxBreakPairs,
    monthlyMeta,
    listLoading,
    canManageWorkersAttendance,
    isSuperAdmin,
    companies,
    companyId,
    handleBackToHome,
    handleAttendanceSaved,
    displaySize,
    height,
    size,
    hasPermissionAddNew,
    elementSegmentedControl,
    pageMode,
    tableFormRef,
    handleSetStateForm,
    hasChanged,
    isError,
    isEditMode,
    handleSave,
    handleCancelEdit,
    isSaving,
    monthlyResult,
    btnPrint,
    elementPrint,
  } = props;

  const [monthPickerPanelKey, setMonthPickerPanelKey] = useState(0);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const MONTH_PARSE_FORMATS = [
    DATE_TIME_FORMAT.DATE_MONTH_JP,
    DATE_TIME_FORMAT.DATE_MONTH_JP_M,
    "YYYY/MM",
    "YYYY/M",
    "YYYY-MM",
    "YYYY-M",
  ];

  const commitMonth = (raw: string | Moment | null) => {
    if (raw == null || (typeof raw === "string" && !String(raw).trim())) {
      return;
    }
    const parsed = moment.isMoment(raw)
      ? raw
      : moment(String(raw).trim(), MONTH_PARSE_FORMATS, true);
    if (!parsed.isValid()) return;
    if (parsed.isAfter(moment(), "month")) return;
    onMonthChange(parsed);
  };

  const handleMonthKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    event.stopPropagation();
    const input = event.currentTarget.querySelector("input");
    commitMonth(input?.value ?? "");
  };

  const formattedMonthlyRecords = () => {
    return monthlyRecords.map((record: any) => ({
      ...record,
      working_time: formatTimeWithDecimal(record.working_time),
      break_time: formatTimeWithDecimal(record.break_time),
    }));
  };

  return (
    <StylesMain compactShell>
      <Styles text_scale={displaySize}>
        <header
          className={`list-tracking-header-bar${
            isMobileOrTablet ? "" : " list-tracking-header-bar--desktop"
          }`}
        >
          <div className="flex-1">
            <div className="list-tracking-header-center d-flex gap-2 align-item-center justify-between ">
              <div className="d-flex gap-2 align-item-center justify-between ">
                <HeaderTitle title="勤怠管理" />
              </div>
              {!isMobileOrTablet && (
                <ButtonBack
                  icon={<UndoIcon direction="right" />}
                  className="btn-back"
                  onClick={handleBackToHome}
                  displaySize={displaySize}
                  showConfirm={false}
                />
              )}
            </div>
          </div>
          {isMobileOrTablet && (
            <div className="list-tracking-header-actions">
              <button
                type="button"
                className="list-tracking-back-btn"
                onClick={handleBackToHome}
                style={{
                  fontSize: size,
                  height: height,
                  width: "fit-content",
                  gap: 5,
                }}
              >
                <HiArrowUturnLeft size={20} />
                <span>戻る</span>
              </button>
            </div>
          )}
        </header>

        <div>
          <div className="d-flex align-item-center justify-between gap-2">
            <div className="d-flex align-item-center gap-3">
              <div className="month-picker-wrap">
                <CommonDatePicker
                  key={monthPickerPanelKey}
                  suffixIcon={<MdOutlineKeyboardArrowDown size={24} />}
                  allowClear={false}
                  displayFormat={DATE_TIME_FORMAT.DATE_MONTH_JP}
                  picker="month"
                  popupClassName="month-picker"
                  value={monthPickerValue}
                  defaultPickerValue={monthPickerValue}
                  onOpenChange={(open) => {
                    if (!open) {
                      setMonthPickerPanelKey((k) => k + 1);
                    }
                  }}
                  disabled={isEditMode}
                  onChange={(_saved, date) => commitMonth(date)}
                  onKeyDown={handleMonthKeyDown}
                  disabledDate={(current) =>
                    current && current.isAfter(moment.now(), "month")
                  }
                  style={{
                    width: isMobileOrTablet ? 130 : 170,
                  }}
                />
              </div>
              {!isMobileOrTablet && (
                <MonthlySummary
                  fontSize={size}
                  loading={!!listLoading}
                  summary={monthlyResult?.summary}
                />
              )}
            </div>
            <DayChangeTimeSetting
              displaySize={displaySize}
              isEditMode={isEditMode}
            />
          </div>
          {isMobileOrTablet && (
            <MonthlySummary
              fontSize={size}
              loading={!!listLoading}
              summary={monthlyResult?.summary}
            />
          )}
        </div>
        <TableList
          preHeaderChildren={
            <div className="">
              <div
                className="d-flex"
                style={{ gap: 8, alignItems: "center", flexFlow: "wrap" }}
              >
                <Tooltip title="開発中" color="#6BC77A">
                  <div>
                    <ButtonCommon
                      icon={<UndoIcon direction="right" />}
                      name="元に戻す"
                      disabled={true}
                      displaySize={displaySize}
                      className="non_css"
                    />
                  </div>
                </Tooltip>
                <Tooltip title="開発中" color="#6BC77A">
                  <div>
                    <ButtonCommon
                      iconRight={<UndoIcon direction="left" />}
                      name="やり直し"
                      disabled={true}
                      displaySize={displaySize}
                      className="non_css"
                    />
                  </div>
                </Tooltip>
                <ToolbarSeparator height={height + 5} />
                <Tooltip title="開発中" color="#6BC77A">
                  <div>
                    <ButtonCommon
                      name="一括削除"
                      disabled={true}
                      displaySize={displaySize}
                      className="non_css"
                    />
                  </div>
                </Tooltip>
                <Tooltip title="開発中" color="#6BC77A">
                  <div>
                    <ButtonCommon
                      name="他社共有"
                      disabled={true}
                      displaySize={displaySize}
                      className="non_css"
                    />
                  </div>
                </Tooltip>
                <ToolbarSeparator height={height + 5} />
                {elementSegmentedControl}
                <ToolbarSeparator height={height + 5} />
                <ButtonCommon
                  name="新規追加"
                  className="non_css"
                  disabled={!hasPermissionAddNew || isEditMode}
                  icon={
                    <div className="flex-center">
                      <BiPlus size={18} />
                    </div>
                  }
                  onClick={() => setIsAddModalOpen(true)}
                  displaySize={displaySize}
                />
              </div>
            </div>
          }
          elementBetweenHeaderAndTable={
            isEditMode && (
              <div className="d-flex gap-2" style={{ marginBottom: 8 }}>
                <ButtonCommon
                  name="保存"
                  icon={
                    <div className="flex-center">
                      <BiSave size="18" />
                    </div>
                  }
                  onClick={handleSave}
                  loading={isSaving}
                  disabled={isSaving || !hasChanged || isError}
                  className={isError ? "btn-save-error" : ""}
                  displaySize={displaySize}
                />
                <ButtonCancel
                  displaySize={displaySize}
                  onClick={handleCancelEdit}
                  disabled={isSaving}
                  loading={isSaving}
                  showConfirm={hasChanged}
                />
                {btnPrint}
              </div>
            )
          }
          monthlyRecords={formattedMonthlyRecords()}
          monthlyMaxBreakPairs={monthlyMaxBreakPairs}
          monthlyMeta={monthlyMeta}
          loading={listLoading}
          currentPage={page}
          pageSize={perPage}
          onChangePagination={onChangePagination}
          canManageWorkersAttendance={canManageWorkersAttendance}
          isSuperAdmin={isSuperAdmin}
          companies={companies}
          activeCompanyNameFallback={
            companies.find((c) => String(c.id) === String(companyId))?.name ||
            ""
          }
          headerHeight={height}
          companyId={companyId}
          onAttendanceSaved={handleAttendanceSaved}
          tableFormRef={tableFormRef}
          isEditMode={pageMode === MODE.EDIT}
          handleSetStateForm={handleSetStateForm}
        />

        {elementPrint}
        <AddTrackingModal
          open={isAddModalOpen}
          companyId={companyId}
          onClose={() => setIsAddModalOpen(false)}
          onSaved={handleAttendanceSaved}
        />
      </Styles>
    </StylesMain>
  );
};

const ListTracking: FC<ReceivedProps> = (props) => (
  <ListTrackingLayout {...useListTracking(props)} />
);

export default ListTracking;
